export class EBTagsInputElement extends HTMLElement {
    #input;
    #container;
    #tags = [];

    constructor() {
        super();

        this.#container = document.createElement("div");
        this.#container.className = "eb-tags-input__chips";

        this.#input = document.createElement("input");
        this.#input.type = "text";
        this.#input.className = "eb-tags-input__input";

        this.appendChild(this.#container);
        this.appendChild(this.#input);

        this.#input.addEventListener("keydown", (event) => {
            if (event.key !== "Enter") return;
            event.preventDefault();

            const value = this.#normalizeValue(this.#input.value);
            if (value === "") {
                this.#input.value = "";
                return;
            }

            this.#addTag(value);
            this.#input.value = "";
            this.dispatchEvent(new Event("change"));
        });
    }

    connectedCallback() {
        const describedBy = this.getAttribute("aria-describedby");
        if (describedBy) this.#input.setAttribute("aria-describedby", describedBy);

        const placeholder = this.getAttribute("placeholder");
        if (placeholder) this.#input.setAttribute("placeholder", placeholder);

        this.#input.disabled = this.disabled;
        this.#render();
    }

    get value() {
        if (this.getAttribute("serialize") === "array") {
            return [...this.#tags];
        }
        return this.#tags.join(",");
    }

    set value(raw) {
        this.#tags = this.#parseIncoming(raw);
        this.#render();
    }

    get disabled() {
        return this.hasAttribute("disabled");
    }

    set disabled(value) {
        if (value) this.setAttribute("disabled", "");
        else this.removeAttribute("disabled");

        this.#input.disabled = !!value;
        for (let button of this.#container.querySelectorAll("button")) {
            button.disabled = !!value;
        }
    }

    #normalizeValue(value) {
        let normalized = (value || "").toString().trim();
        if (this.getAttribute("normalize") === "lowercase") {
            normalized = normalized.toLowerCase();
        }
        if (normalized.startsWith("@")) normalized = normalized.substring(1);
        return normalized;
    }

    #parseIncoming(raw) {
        if (Array.isArray(raw)) {
            const values = raw
                .map(value => this.#normalizeValue(value))
                .filter(value => value !== "");
            return [...new Set(values)];
        }

        const values = (raw || "")
            .toString()
            .split(/[\n,;]+/g)
            .map(value => this.#normalizeValue(value))
            .filter(value => value !== "");

        return [...new Set(values)];
    }

    #addTag(value) {
        if (this.#tags.includes(value)) return;
        this.#tags.push(value);
        this.#render();
    }

    #removeTag(value) {
        const index = this.#tags.indexOf(value);
        if (index === -1) return;
        this.#tags.splice(index, 1);
        this.#render();
        this.dispatchEvent(new Event("change"));
    }

    #render() {
        this.#container.innerHTML = "";

        for (let tag of this.#tags) {
            const button = this.#container.appendChild(document.createElement("button"));
            button.type = "button";
            button.className = "eb-tags-input__tag";
            button.setAttribute("data-eb-tag", tag);
            button.disabled = this.disabled;
            button.innerHTML = `<span aria-hidden="true">${tag}</span><svg class="toggle" data-src="/assets/images/remove.svg" aria-hidden="true"></svg>`;
            button.addEventListener("click", () => this.#removeTag(tag));
        }
    }
}

customElements.define("eb-tags-input", EBTagsInputElement);
